import { LicenseInfo } from '@mui/x-license';

import { assertVersionAndTTLValid, updateWidgetsMeta } from 'src/state/localstorage';

assertVersionAndTTLValid();
updateWidgetsMeta();

import { createHashHistory } from 'history';

export const history = createHashHistory();

// Add license key for Mui X Pro components.
// (it's supposed to be public)
// https://mui.com/x/advanced-components/#security
LicenseInfo.setLicenseKey(
    // eslint-disable-next-line max-len
    'aba1224f2b664d5226f0aff2d671e7beTz0xMzAxNDcsRT0xODEyODQ0Nzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=',
);
